module.exports = __webpack_public_path__ + "fa4a345732709516450c5e17f95cfb61.svg";